import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
	counterText: {
		color: theme.palette.grey[400]
	}
}));